import { Instance } from 'mobx-state-tree'
import { Editor } from 'src/api/stores/Editor'
import { Configuration } from 'src/api/stores/Configuration'
import { Preview } from 'src/api/stores/Preview'
import { MenuItemProps } from 'src/components/layout/Navigation/Menu'
import { default as sides, orbit } from 'src/constants/sides'
import { navigate } from 'gatsby'
import { RouteState } from 'src/constants/routes'
import { editor } from 'src/constants/typenames'
import upperFirst from 'lodash/upperFirst'
import { IPreview } from 'src/api/stores/Preview/types'
import { IEditor } from 'src/api/stores/Editor/types'

type NavItem = {
  title: string
  items?: MenuItemProps[]
}

export type NavItemKey = keyof ReturnType<typeof getNavConfig>

export const getNavConfig: (
  config: RouteState
) => { [key: string]: DeepPartial<NavItem> } = config => {
  const view = config.view
  const isEditor = Boolean(config.view?.__typename === editor)
  return {
    /** */
    ...(config.store && {
      project: {
        title: 'Project',
        items: [
          {
            children: 'New Project',
            onClick: () => {
              const {
                draft: { id }
              } = config.store?.createProject()
              navigate(`/project/${id}/setup/name`)
            }
          },
          { children: 'Open Recent' },
          { children: 'Rename' },
          { children: 'Edit Description' }
        ]
      }
    }),
    /** */
    ...(isEditor && {
      edit: {
        title: 'Edit',
        items: [
          { children: 'Undo', onClick: () => view.undoable && view.undo() },
          { children: 'Redo', onClick: () => view.redoable && view.redo() }
        ]
      }
    }),
    /** */
    configuration: {
      title: 'Configuration',
      items: [{ children: 'Project' }, { children: 'Content' }, { children: 'Enclosure' }]
    },
    /** */
    object: {
      title: 'Object',
      items: [{ children: 'lock' }]
    },
    /** */
    ...(view && {
      view: {
        title: 'View',
        items: [
          { children: 'Zoom In', onClick: () => view.currentView.zoomIn() },
          { children: 'Zoom Out', onClick: () => view.currentView.zoomOut() },
          { children: 'Zoom To Fit All', onClick: () => view.currentView.fit({}) },
          { children: '3D View', onClick: () => view.switchSide(orbit) },
          ...([...sides].reduce(
            (p, side) => [
              ...p,
              { children: `${upperFirst(side)} View`, onClick: () => view.switchSide(side) }
            ],
            [] as MenuItemProps[]
          ) as MenuItemProps[])
        ]
      }
    }),
    /** */
    help: {
      title: 'Help'
    },
    /** */
    account: {
      title: 'Account',
      items: [
        { children: 'Profil', onClick: () => navigate('/profil') },
        { children: 'Orders', onClick: () => navigate('/orders') },
        { children: 'Logout', onClick: () => navigate('/logout') }
      ]
    }
  }
}
